module.exports = __webpack_public_path__ + "fonts/Manrope-600-greek15.4f6140c.woff2";